import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledLabel = styled.span`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  font-weight: 700;
`;

export const StyledSwitchToggleWrapper = styled.div`
  > div {
    display: flex;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('16px')} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  width: 100%;
`;
